import React from "react";

const GridView = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M2 2.002h14.222v14.22H2V2v.002zm0 17.774h14.222v14.222H2V19.776zM19.778 2.003H34v14.221H19.778V2v.003zm0 17.774H34V34H19.778V19.777z"
          fill={fill}
      />
    </svg>
);

export default GridView;
